// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-wrapper {
  cursor: pointer;
}
.checkbox-wrapper input {
  display: none;
}
.checkbox-wrapper .label-wrapper .label {
  color: #101010;
}
.checkbox-wrapper .label-wrapper .sub-text {
  color: #717171;
}
.checkbox-wrapper .checkbox-select {
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 4px;
  background-color: #FDFDFD;
  border: 1px solid #B7B7B7;
}
.checkbox-wrapper:hover .checkbox-select {
  border: 1px solid #101010;
}
.checkbox-wrapper.checked .checkbox-select {
  background-color: #101010;
  border: 1px solid #101010;
}
.checkbox-wrapper.disabled {
  cursor: not-allowed;
}
.checkbox-wrapper.disabled .checkbox-select {
  border: 1px solid #B7B7B7;
}
.checkbox-wrapper.disabled.checked .checkbox-select {
  background-color: #F3F3F3;
}
.checkbox-wrapper.disabled .label-wrapper .label,
.checkbox-wrapper.disabled .label-wrapper .sub-text {
  color: #B7B7B7;
}
.checkbox-wrapper .checkmark {
  top: 3px;
  left: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/checkbox/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,aAAA;AACJ;AAGI;EACE,cAAA;AADN;AAII;EACE,cAAA;AAFN;AAME;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAJJ;AAQI;EACE,yBAAA;AANN;AAWI;EACE,yBAAA;EACA,yBAAA;AATN;AAaE;EACE,mBAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;AAcI;EACE,yBAAA;AAZN;AAgBM;;EAEE,cAAA;AAdR;AAmBE;EACE,QAAA;EACA,SAAA;AAjBJ","sourcesContent":[".checkbox-wrapper {\n  cursor: pointer;\n\n  input {\n    display: none;\n  }\n\n  .label-wrapper {\n    .label {\n      color: theme('colors.black');\n    }\n\n    .sub-text {\n      color: theme('colors.grey-70');\n    }\n  }\n\n  .checkbox-select {\n    width: 24px;\n    height: 24px;\n    padding: 4px;\n    border-radius: 4px;\n    background-color: theme('colors.white');\n    border: 1px solid theme('colors.grey-50');\n  }\n\n  &:hover {\n    .checkbox-select {\n      border: 1px solid theme('colors.black');\n    }\n  }\n\n  &.checked {\n    .checkbox-select {\n      background-color: theme('colors.black');\n      border: 1px solid theme('colors.black');\n    }\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .checkbox-select {\n      border: 1px solid theme('colors.grey-50');\n    }\n\n    &.checked .checkbox-select {\n      background-color: theme('colors.grey-10');\n    }\n\n    .label-wrapper {\n      .label,\n      .sub-text {\n        color: theme('colors.grey-50');\n      }\n    }\n  }\n\n  .checkmark {\n    top: 3px;\n    left: 3px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
